import { Navigate } from 'react-router-dom';
import { useEffect } from 'react';
import { useSecurityToken } from '../../utils/security';

export default function LogoutComponent() {
  const [, setToken] = useSecurityToken();

  useEffect(() => {
    setToken(null);
  });

  return <Navigate to="/" />;
}
